// select spa location
import React from "react";
import { useState, useEffect } from "react";
import Loader from "../../UI/loader";
 import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { getActivityLocations } from "../../../action/activityBooking";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { scrollToTop } from "../../../JS/scrollToTop";







function Activities1(props) {
  const {t}= props;
  const [error, setError] = useState({isError:false,errorMsg:""});
  const [activityLocationData, setActivityLocationData] = useState(null);
  const [showLoader, setShowLoader]= useState(false);
  let imagePath;

  let room = localStorage.getItem("room");
    let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");


  const handleNext = (selectedLocation) => {
    props.next({
      spaLocationId: selectedLocation.spalocationId,
      spaName: selectedLocation.spaName,
      spaDescription: selectedLocation.spaDescription
    })
  }

  const sendTheAnalytics = (isSuccess) => {
    try {

      props.sendAnalytics(
        props.guestDetail,
        props.currentWidgets.widgetType,
        isSuccess ? "FETCH SPA Location DATA - SUCCESS" : "FETCH SPA Location DATA - FAIL",
        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
        0,
        props.guestIsLoggedIn
      );
    }catch(error){
      return error;
    }

}


  const fetchActivityLocations = () => {
    setShowLoader(true);
    setError({ isError: false, errorMsg: "" })
    getActivityLocations(props.currentWidgets.spaLocationId )
      .then((res) => {
        if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {

          const data = res.data.payload.data;

          props.setCachedApiDataStore({...props.cachedApiDataStore, "activity_locations":data})
          setActivityLocationData(data);


          sendTheAnalytics(true)

        } else {
           sendTheAnalytics(false)
          setError({ isError: true, errorMsg: (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg)||t("activityBooking.error.fetchActivityLocations")||''})

         
        }

      })

      .catch(() => {
        setError({ isError: true, errorMsg:  t("activityBooking.error.fetchActivityLocations") || '' })
      })

      .finally(() => {
        setShowLoader(false)
      })
  }

  const getLocations =()=>{
    if (props.cachedApiDataStore && props.cachedApiDataStore.hasOwnProperty("activity_locations")){
      setActivityLocationData(props.cachedApiDataStore["activity_locations"]);
    }else{
      fetchActivityLocations();
    }
  }

  const startFlow=()=>{
    if (room && room != "null") {
      getLocations();
    } else {
      if (process.env.REACT_APP_INROOMTAB == "true") {
        props.setLoginRequired(true);
      } else {
        props.setRegPage(true);
      }
    }
  }

  useEffect(()=>{

  
    if (activityLocationData && activityLocationData.length > 0 && props.currentWidgets.spaLocationId)
      {
      const spaLocationData =   activityLocationData.find((act) => act.spalocationId == props.currentWidgets.spaLocationId);
      handleNext(spaLocationData);
      }
  }, [activityLocationData])
  
 

  useEffect(() => {
    scrollToTop();
    startFlow();
  }, [])


  return (
    <>
      <header className="inner-pages w-footer subpages">
        <a className="button-back" onClick={() => props.handleGoBack()}></a>
        <div className="heading align-center">
          <div class="splash-brand">
            <img src={`${CMSPath}${props.logo}`} />
          </div>
        </div>
      </header>

      {
        error.isError
          ? <SuccessFailScreen status={false} showTryAgain={true} showClose={true} statusMessage1={t(`activityBooking.error.error`)} statusMessage2={error.errorMsg || t('activityBooking.error.unable_process_request')} close={() => props.setGoHome(true)} tryAgain={() => startFlow()} />
          : <>
            <section class="widgets spa-listing">
              <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl && (
                  <div class="widget-header-img">
                    <img
                      src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                      alt={props.currentWidgetObj.displayName}
                    />
                  </div>
                )}

                <div class="widget-header-title">{t(`activityBooking.act1_heading`)}</div>
                {/* <div class="widget-header-subtitle">
                {t(`activitiesBooking.act1_subheading`)}
          </div> */}
                
              </div>
 
         


              <div class="row">
                <div class="col sm-banner">
                  <div class="col sm-banner">
                    {activityLocationData && activityLocationData.length>0 && activityLocationData.map((iterator) => {
                      imagePath = iterator.imageName
                        ? encodeURI(`${CMSPath}${iterator.imageName}`)
                        : "";

                      return (
                        <a
                          id={iterator.widgetType}
                          className={"tile-sm thumbnails tile-container"}
                          onClick={() => {
                            handleNext(iterator);
                          }}
                        >
                          <div class="thumb-img">
                            {imagePath ? <img src={imagePath}></img> : ""}
                          </div>

                          <div class="thumb-text">
                            <p class="thumb-heading">{iterator.spaName}</p>

                            <p class="thumb-description">{iterator.spaDescription}</p>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>

            
          </>
      }
      {
        showLoader && <Loader displayMsg={t("activityBooking.loader_msg.locations")} /> // check whether to show close button, 
      }
    </>
  )
}


const mapStateToProps = state => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
  }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, setLoginRequired, setRegPage }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Activities1));
